<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2f1"><a id="page_vi"></a><a id="page_vii"></a>CONTENTS</h2>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td style="width:22%" valign="top"><p class="toc"> </p></td>
<td style="width:78%" valign="top"><p class="toc2"><a href="#/xhtml/illustrations#ill">List of Illustrations</a></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><a href="#/xhtml/foreword#for">Foreword</a></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc3"><em>Alfre Woodard</em></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><a href="#/xhtml/preface#pre">Preface</a></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><a href="#/xhtml/chronology#chr">Chronology</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc4"><strong>PART</strong></p></td>
<td valign="top"><p class="toc2"> </p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"><a href="#/xhtml/part01#part1">ONE</a></p></td>
<td valign="top"><p class="toc1"><a href="#/xhtml/part01#part1">Blessed by Experiences</a></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><a href="#/xhtml/chapter01#ch1"><em>1. Conversations with a Former President</em></a></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><a href="#/xhtml/chapter02#ch2"><em>2. Courting the Superdelegates</em></a></p></td>
</tr>
<tr>
<td valign="middle"><p class="toct"><a href="#/xhtml/part02#part2">TWO</a></p></td>
<td valign="top"><p class="toc1t"><a href="#/xhtml/part02#part2">A Blessed Beginning</a></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><a href="#/xhtml/chapter03#ch3"><em>3. Inherited Values</em></a></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample"><em>4. A World without Blinders</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample"><em>5. The Young Clyburns</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toct"><span href="#/xhtml/part03#part3" title="Link target outside of Sample">THREE</span></p></td>
<td valign="top"><p class="toc1t"><span href="#/xhtml/part03#part3" title="Link target outside of Sample">Finding My Way</span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter06#ch6" title="Link target outside of Sample"><em>6. Into the Streets</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter07#ch7" title="Link target outside of Sample"><em>7. Back to the Basics</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toct"><span href="#/xhtml/part04#part4" title="Link target outside of Sample">FOUR</span></p></td>
<td valign="top"><p class="toc1t"><span href="#/xhtml/part04#part4" title="Link target outside of Sample">The Charleston Shuffle</span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter08#ch8" title="Link target outside of Sample"><em>8. Two Steps to the West</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter09#ch9" title="Link target outside of Sample"><em>9. Two Steps to the East</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample"><em>10. Two Steps Forward</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample"><em>11. One Step to the Rear</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toct"><span href="#/xhtml/part05#part5" title="Link target outside of Sample">FIVE</span></p></td>
<td valign="top"><p class="toc1t"><span href="#/xhtml/part05#part5" title="Link target outside of Sample">Making History</span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample"><em>12. Trailblazer</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample"><em>13. Myth Buster</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toct"><span href="#/xhtml/part06#part6" title="Link target outside of Sample">SIX</span></p></td>
<td valign="top"><p class="toc1t"><span href="#/xhtml/part06#part6" title="Link target outside of Sample">A Racial Arbiter</span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample"><em>14. The Chester Controversy</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample"><em>15. The Citadel Confrontation</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><a id="page_viii"></a><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample"><em>16. The Conway Crisis</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample"><em>17. The Confederate Battle Flag</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toct"><span href="#/xhtml/part07#part7" title="Link target outside of Sample">SEVEN</span></p></td>
<td valign="top"><p class="toc1t"><span href="#/xhtml/part07#part7" title="Link target outside of Sample">Coming to Grips with Reality</span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample"><em>18. A Day of Reckoning</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample"><em>19. Reaffirming My Goals</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toct"><span href="#/xhtml/part08#part8" title="Link target outside of Sample">EIGHT</span></p></td>
<td valign="top"><p class="toc1t"><span href="#/xhtml/part08#part8" title="Link target outside of Sample">The Dream Realized</span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample"><em>20. Deciding to Run for Congress</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample"><em>21. Adventures in Campaigning</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample"><em>22. Primary Election Day, 1992</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample"><em>23. General Election, 1992</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toct"><span href="#/xhtml/part09#part9" title="Link target outside of Sample">NINE</span></p></td>
<td valign="top"><p class="toc1t"><span href="#/xhtml/part09#part9" title="Link target outside of Sample">Mr. Clyburn Goes to Washington</span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample"><em>24. Arriving in Congress</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample"><em>25. Playing Hardball Clinton Style</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample"><em>26. My First Bill</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample"><em>27. Building Friendships</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toct"><span href="#/xhtml/part10#part10" title="Link target outside of Sample">TEN</span></p></td>
<td valign="top"><p class="toc1t"><span href="#/xhtml/part10#part10" title="Link target outside of Sample">Treading and Toiling</span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter28#ch28" title="Link target outside of Sample"><em>28. Wandering in the Wilderness</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter29#ch29" title="Link target outside of Sample"><em>29. Principles above Politics</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter30#ch30" title="Link target outside of Sample"><em>30. Service above Self</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toct"><span href="#/xhtml/part11#part11" title="Link target outside of Sample">ELEVEN</span></p></td>
<td valign="top"><p class="toc1t"><span href="#/xhtml/part11#part11" title="Link target outside of Sample">The Age of Obama</span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter31#ch31" title="Link target outside of Sample"><em>31. 3-V Day: Victory, Validation, Vindication</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter32#ch32" title="Link target outside of Sample"><em>32. Barack and Me</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter33#ch33" title="Link target outside of Sample"><em>33. Reforming Health Care</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter34#ch34" title="Link target outside of Sample"><em>34. Reducing the Deficit</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toct"><span href="#/xhtml/part12#part12" title="Link target outside of Sample">TWELVE</span></p></td>
<td valign="top"><p class="toc1t"><span href="#/xhtml/part12#part12" title="Link target outside of Sample">Blessed by the Past</span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter35#ch35" title="Link target outside of Sample"><em>35. Genuinely Southern</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2"><span href="#/xhtml/chapter36#ch36" title="Link target outside of Sample"><em>36. Proudly Black</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample"><em>Epilogue</em></span></p></td>
</tr>
<tr>
<td valign="middle"><p class="toc"> </p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?46e22f70